module.exports = __webpack_public_path__ + "img/four.59480482.jpg";